import api from './authService';

export const getAuthUrl = () => {
  return api.get('/google-calendar/auth-url');
};

export const completeAuth = (code) => {
  return api.post('/google-calendar/callback', { code });
};

export const syncCalendar = (options = {}) => {
  return api.post('/google-calendar/sync', options);
};

export const getStatus = () => {
  return api.get('/google-calendar/status');
};

export const disconnect = () => {
  return api.post('/google-calendar/disconnect');
};
